<template>
  <div>
  <!-- Layout inner -->

    <div class="layout-inner program_guide program_guide_faq program_guide_compliance">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>

          <template v-if="showPage">
            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <div class="container-fluid flex-grow-1 pg_content_container">
              <div class="row">
                <div class="col-12">

                  <div class="row pg_top_sec">

                    <div class="col-12 pg_sec_hd">
                      <div class="row">
                        <div class="col-6" v-if="programGuide.institutionSpecificInfo.label">
                          {{programGuide.institutionSpecificInfo.label}}
                        </div>
                        <div class="col-6 compliant_score_val" v-if="programGuide.institutionSpecificInfo.tag">
                          <span>{{programGuide.institutionSpecificInfo.tag}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 thumbnail_container mt-3">
                      <div v-if="programGuide.institutionSpecificInfo.iconUrl">
                          <img :src="programGuide.institutionSpecificInfo.iconUrl" class="img_h_100">
                      </div>
                    </div>

                    <div class="col-12 mt-3" v-if="programGuide.institutionSpecificInfo.detail" v-html="programGuide.institutionSpecificInfo.detail">
                    </div>

                  </div>

                  <div class="row sub_hd_bar">
                    <div class="col-12 srh_bx">
                      <input placeholder="search" aria-label="search" v-model="searchTerm" v-on:keyup.enter="searchClicked">
                      <span @click="searchClicked" class="search-icon"/>
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                  </div>

                  <template v-if="filteredCompliance.length == 0">
                    <div class="list_row">
                        No results found!
                    </div>
                  </template>

                <template v-for="(compliance, i) in filteredCompliance">
                  <template v-if="(compliance.items && compliance.items.length>0)">
                    <div class="accordion_panel">
                      <div class="row accordion">
                        <div class="col-12 accordion_crd">
                          <b-card-header header-tag="header" class="row head" role="tab"  block v-b-toggle="('req_'+i)" variant="info">
                            <div class="col-1 ic_container">
                              <div class="ic ic-expand_r"></div>
                              <div class="ic ic-collapse_r"></div>
                            </div>
                            <div class="col-10 hd_txt">
                              <div>{{compliance.label}}</div>
                            </div>
                          </b-card-header>

                          <b-collapse :id="'req_'+i" visible role="tabpanel">
                            <b-card-body class="accordion_crd_content">

                                <div class="row" v-if="compliance.detail">
                                  <div class="col-12 p-3">
                                    <div class="description pl-3 pr-3" v-html="compliance.detail"></div>
                                  </div>
                                </div>

                                <div class="self_reported_courses">
                                  <div class="list_container">
                                    <template v-for="(complianceItem, j) in compliance.items">
                                        <div class="list_row">
                                          <div class="col-12 sec_txt">
                                            <div v-html="parseParams(complianceItem.title)"></div>
                                          </div>
                                        </div>
                                        <div class="list_row">
                                          <div class="col-12 sec_txt">
                                            <div v-html="parseParams(complianceItem.description)"></div>
                                          </div>
                                        </div>
                                    </template>
                                  </div>
                                </div>
                            </b-card-body>
                          </b-collapse>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
            </div>
          </div>
          </div>

          <program-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>

          </template>
        </div>
      </div>
		</div>
    <!-- Layout inner -->

    <div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
export default {
  name: 'program-guide-compliance',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    Navbar,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      isDataLoaded: false,
      DEFAULT_TYPE: 'MAJOR',
      programGuide: {},
      showPage: false,
      searchTerm:'',
      searchCompliance : '',
      filteredCompliances:[],
      showLoader: true,
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults'
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers'
    ]),
    searchClicked () {
      if(!this.searchTerm){
          this.filteredCompliances = this.programGuide.institutionSpecificInfo.subGroups
      }else{
          let filtered = []
          this.programGuide.institutionSpecificInfo.subGroups.forEach((compliance) => {
              let newCompliance  = {'label':compliance.label, 'items':[]}
              compliance.items.forEach((item) => {
                  if(item.title.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 || item.description.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 )
                  newCompliance.items.push(item)
              });
              filtered.push(newCompliance)
          });
          this.filteredCompliances = filtered;
      }
    },
    async loadProgramGuideInfo () {
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.filteredCompliances = (this.programGuide.institutionSpecificInfo && this.programGuide.institutionSpecificInfo.subGroups)? this.programGuide.institutionSpecificInfo.subGroups:[]
      this.showLoader = false
      this.showPage = true
    },
    parseParams(value){
      let parsedValue = value
      if(parsedValue.indexOf('[MEDIAN_INCOME]')!=-1) {
        let medianIncome = this.programGuide.medianIncomePerYear
         medianIncome = medianIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        parsedValue = value.replace('[MEDIAN_INCOME]', '$' + medianIncome)
      }
      if(parsedValue.indexOf('[GROWTH_RATE]')!=-1) {
        let growthRate = parseFloat(this.programGuide.growthRate).toFixed(1)
        parsedValue = parsedValue.replace('[GROWTH_RATE]', growthRate+'%')
      }
      if(parsedValue.indexOf('[CREDENTIALS]')!=-1) {
        let credList = '<ul>'
        if(this.programGuide.credentialList.length>0){
            for(let i=0;i<this.programGuide.credentialList.length;i++){
                credList+='<li>'+this.programGuide.credentialList[i].title+'</li>'
            }
        }
        credList+='</ul>'
        parsedValue = parsedValue.replace('[CREDENTIALS]', credList)
      }
      if(parsedValue.indexOf('[CREDIT_TRANSFER]')!=-1) {
        let transfer = '<ul>'
        if(this.programGuide.relatedProgramsCreditInfo.length>0){
            for(let i=0; i<this.programGuide.relatedProgramsCreditInfo.length;i++){
                transfer+='<li>'+this.programGuide.relatedProgramsCreditInfo[i].transferred+' credits towards  '+this.programGuide.relatedProgramsCreditInfo[i].programName+'</li>'
            }
        }
        transfer+='</ul>'
        parsedValue = parsedValue.replace('[CREDIT_TRANSFER]', transfer)
      }
      if(parsedValue.indexOf('[MODALITY_TYPE]')!=-1) {
        let modalityType = this.getModalityValue(this.programGuide.modalityType)
        parsedValue = parsedValue.replace('[MODALITY_TYPE]', modalityType)
      }
      if(parsedValue.indexOf('[FUNDING_TYPE]')!=-1) {
        let fundingType = this.getFundingValue(this.programGuide.fundingType)
        parsedValue = parsedValue.replace('[FUNDING_TYPE]', fundingType)
      }

      return parsedValue
    },
    getModalityValue(key){
        let arr = [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },
  computed: {
    ...mapState({
      'packages': state => state.institution.packages
    }),
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    filteredCompliance () {
      return this.filteredCompliances
    },
    noResult () {
       return this.filteredCompliances.length>0
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    returnTo () {
      if (this.isComingFromBookmark) {
        return this.$route.query.returnTo || 'bookmarks'
      }
      return this.$route.query.returnTo || 'programGuideMenu'
    },
    pageTitle () {
      if (this.isComingFromBookmark) {
        return this.$route.query.pageTitle || 'Back To Bookmarks'
      }
      return this.$route.query.pageTitle || 'Compliance'
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCompliance.vue